import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { REGULATOR, USER } from 'config/permissions/roles';
import accountService from 'services/account.service';
import accountComponent from './account.component';

export default
  angular.module('components.app.account', [
    uiRouter
  ])
    .component('account', accountComponent)
    .service('AccountService', accountService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('account', {
          parent: 'app',
          url: '/account',
          component: 'account',
          data: {
            permissions: {
              only: [REGULATOR, USER],
              redirectTo: 'dashboard'
            }
          },
          resolve: {
            accessLevels: AuthService =>
              AuthService.getAccessLevels(),
            user: (AccountService, currentUser) =>
              AccountService.getAccount(currentUser.UserId).then(r => r.data)
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/account/account.module.js